import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'
import { type Metadata } from '@redteclab/api/clients/retail-media-xsell-service'

export const gkAirAccessorGetSponsoredProductLink = ({
  metadata,
  product,
}: {
  metadata?: Metadata
  product?: GkAirRecommendedProductDataWeb
}): string | undefined => {
  const metadataContent = product?.UID
    ? metadata?.[product.UID as keyof Metadata]
    : undefined

  /*
   * retail media click url is used instead of original deeplink
   * this property is defined only if the product is re-rank or injected from retail media service
   * it allows to track the clicks on the product
   */
  return metadataContent?.trackingUrls.clickUrl
}
